import React, { useContext } from "react"
import AppContext from "../../shared/AppContext"

const FeedbackQuestionNavigator = (props) => {
  const {
    currentIdx,
    numOfQuestions,
    setCurrentIdx,
    setIsFinished,
    question,
    answer,
  } = props

  const { trackEvent } = useContext(AppContext)

  const isFirst = currentIdx === 0
  const isLast = currentIdx + 1 === numOfQuestions

  const questionDisplayNumber = currentIdx + 1 + "/" + numOfQuestions

  const onPreviousClick = () => {
    setCurrentIdx(currentIdx - 1)

    trackEvent("Continue Survey", {
      question,
      answer,
      event: "previous",
      "survey step": questionDisplayNumber,
    })
  }
  const onNextClick = () => {
    setCurrentIdx(currentIdx + 1)
    trackEvent("Continue Survey", {
      question,
      answer,
      event: "next",
      "survey step": questionDisplayNumber,
    })
  }
  const onFinishClick = () => {
    setIsFinished(true)

    trackEvent("Continue Survey", {
      question,
      answer,
      event: "finish",
      "survey step": questionDisplayNumber,
    })
  }

  return (
    <div className="modal-bottom-button-container">
      {!isFirst ? (
        <button
          data-cy="previous-button"
          className="previous"
          onClick={onPreviousClick}
        >
          Previous
        </button>
      ) : null}
      {!isLast ? (
        <button
          data-cy="next-button"
          className="next right"
          onClick={onNextClick}
        >
          Next
        </button>
      ) : (
        <button
          data-cy="finish-button"
          className="finish right"
          onClick={onFinishClick}
        >
          Finish
        </button>
      )}
    </div>
  )
}

export default FeedbackQuestionNavigator
